define("shared/components/shared/ui/switcher", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/debug", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "lodash", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _debug, _object, _service, _component2, _tracking, _emberConcurrency, _lodash, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _changeOption;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/debug",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <PowerSelect
    @afterOptionsComponent={{if
      @action
      (component "shared/ui/switcher/action" icon=@action.icon label=@action.label qaId=@action.qaId task=this.onAction)
    }}
    @allowClear={{@allowClear}}
    @disabled={{@disabled}}
    @dropdownClass={{@dropdownClass}}
    @highlightOnHover={{true}}
    @onChange={{this.onChange}}
    @options={{@options}}
    @optionsComponent={{component "shared/ui/switcher/list" qaId=@dropdownQaId}}
    @placeholderComponent={{component
      "shared/ui/switcher/trigger"
      loading=@loading
      option=this.placeholder
      qaId=@triggerQaId
    }}
    @registerAPI={{this.onRegisterPowerSelectApi}}
    @selected={{this.selectedOption}}
    @selectedItemComponent={{component "shared/ui/switcher/trigger" loading=@loading option=this.selectedOption}}
    class={{concat-classes
      "o--btn"
      "o--btn--r"
      "o--btn--outline"
      "o--page__switcher"
      "o--page__switcher--fullWidth"
      "o--page__switcher--noFocus"
      "u--p__l__xs"
    }}
    ...attributes
    as |option select|
  >
    {{#let (eq option.uid this.selectedOption.uid) as |isSelected|}}
      <Shared::Ui::Switcher::Item
        @onClick={{fn this.onClickItem option select}}
        @option={{option}}
        @selected={{isSelected}}
        class={{concat-classes option.className "ember-power-select-option"}}
      />
    {{/let}}
  </PowerSelect>
  */
  {
    "id": "+7XFbUkS",
    "block": "[[[8,[39,0],[[16,0,[28,[37,1],[\"o--btn\",\"o--btn--r\",\"o--btn--outline\",\"o--page__switcher\",\"o--page__switcher--fullWidth\",\"o--page__switcher--noFocus\",\"u--p__l__xs\"],null]],[17,1]],[[\"@afterOptionsComponent\",\"@allowClear\",\"@disabled\",\"@dropdownClass\",\"@highlightOnHover\",\"@onChange\",\"@options\",\"@optionsComponent\",\"@placeholderComponent\",\"@registerAPI\",\"@selected\",\"@selectedItemComponent\"],[[52,[30,2],[50,\"shared/ui/switcher/action\",0,null,[[\"icon\",\"label\",\"qaId\",\"task\"],[[30,2,[\"icon\"]],[30,2,[\"label\"]],[30,2,[\"qaId\"]],[30,0,[\"onAction\"]]]]]],[30,3],[30,4],[30,5],true,[30,0,[\"onChange\"]],[30,6],[50,\"shared/ui/switcher/list\",0,null,[[\"qaId\"],[[30,7]]]],[50,\"shared/ui/switcher/trigger\",0,null,[[\"loading\",\"option\",\"qaId\"],[[30,8],[30,0,[\"placeholder\"]],[30,9]]]],[30,0,[\"onRegisterPowerSelectApi\"]],[30,0,[\"selectedOption\"]],[50,\"shared/ui/switcher/trigger\",0,null,[[\"loading\",\"option\"],[[30,8],[30,0,[\"selectedOption\"]]]]]]],[[\"default\"],[[[[1,\"\\n\"],[44,[[28,[37,5],[[30,10,[\"uid\"]],[30,0,[\"selectedOption\",\"uid\"]]],null]],[[[1,\"    \"],[8,[39,6],[[16,0,[28,[37,1],[[30,10,[\"className\"]],\"ember-power-select-option\"],null]]],[[\"@onClick\",\"@option\",\"@selected\"],[[28,[37,7],[[30,0,[\"onClickItem\"]],[30,10],[30,11]],null],[30,10],[30,12]]],null],[1,\"\\n\"]],[12]]]],[10,11]]]]]],[\"&attrs\",\"@action\",\"@allowClear\",\"@disabled\",\"@dropdownClass\",\"@options\",\"@dropdownQaId\",\"@loading\",\"@triggerQaId\",\"option\",\"select\",\"isSelected\"],false,[\"power-select\",\"concat-classes\",\"if\",\"component\",\"let\",\"eq\",\"shared/ui/switcher/item\",\"fn\"]]",
    "moduleName": "shared/components/shared/ui/switcher.hbs",
    "isStrictMode": false
  });
  let SwitcherComponent = _exports.default = (_class = (_changeOption = /*#__PURE__*/new WeakSet(), class SwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _changeOption);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      /** The PowerSelect's public API for programmatic interaction with the dropdown */
      _initializerDefineProperty(this, "powerSelect", _descriptor2, this);
      _defineProperty(this, "onAction", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (event) {
          (false && !(!!this.powerSelect) && (0, _debug.assert)('PowerSelect API must be properly registered', !!this.powerSelect));
          if ((0, _lodash.isFunction)(this.args.action?.onAction)) {
            // Note: we pass along the PowerSelect's API for programmatic control in the `onAction` handler.
            yield this.args.action.onAction(this.powerSelect, event);
          }
        }
      }), {
        drop: true
      }, "onAction", null));
      (false && !(!!this.args.options && Array.isArray(this.args.options)) && (0, _debug.assert)('SwitcherComponent: argument `options` must be provided', !!this.args.options && Array.isArray(this.args.options)));
    }
    get selectedOption() {
      // Note: if no enabled options were provided, return undefined
      if (!this.args.selectedOption) {
        return undefined;
      }

      // Note: we need to pass in an element directly from the `options` collection we're passing
      // into the PowerSelect component, which means we can only use the `args.selectedOption` for
      // searching for a reference. Not pretty, but it works.
      const selected = this.args.selectedOption;
      const found = this.args.options.find(option => option.uid === selected.uid);
      return found ?? selected; // Note: if for some reason the `find` fails, just pass the original (we'd lose some UI state)
    }
    get placeholder() {
      return this.args.placeholder ?? {
        uid: 'placeholder',
        label: this.intl.t('shared_phrases.select_option'),
        avatar: {
          type: 'icon',
          value: 'add'
        }
      };
    }
    onClickItem(option, select) {
      select.actions.select(option);
      select.actions.close();
    }
    onChange(selection, select, event) {
      _classPrivateMethodGet(this, _changeOption, _changeOption2).call(this, selection, select, event);
    }
    onClear() {
      _classPrivateMethodGet(this, _changeOption, _changeOption2).call(this, undefined);
    }
    onRegisterPowerSelectApi(select) {
      this.powerSelect = select;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "powerSelect", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "onClickItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClickItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClear", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClear"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRegisterPowerSelectApi", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRegisterPowerSelectApi"), _class.prototype)), _class);
  function _changeOption2(option, select, event) {
    if ((0, _lodash.isFunction)(this.args.onChange)) {
      this.args.onChange(option, select, event);
    }
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SwitcherComponent);
});